import { faDownload, faMoon } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { BG_COLOR, DarkMode } from '../../../AIIllustration/types/darkMode';

export function useImageViewer(dataSrc: string | null, filename: string) {
  const [darkMode, setDarkMode] = useState(DarkMode.LIGHT);
  const [isHovering, setIsHovering] = useState(false);

  const toggleDarkMode = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    setDarkMode((d) => (d === DarkMode.LIGHT ? DarkMode.DARK : DarkMode.LIGHT));
  }, []);

  const handleDownload = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    if (!dataSrc) return;
    const a = document.createElement('a');
    a.href = dataSrc;
    a.download = filename;
    a.click();
  }, [dataSrc, filename]);

  return {
    bgColor: BG_COLOR[darkMode],
    isHovering,
    hoverProps: {
      onMouseEnter: () => setIsHovering(true),
      onMouseLeave: () => setIsHovering(false),
    },
    toggleDarkMode,
    handleDownload,
  };
}

interface IProps {
  onDownload: (e: React.MouseEvent) => void;
  onToggleDark: (e: React.MouseEvent) => void;
  size?: number;
  offset?: number;
}

export const ImageViewerButtons: React.FC<IProps> = ({ onDownload, onToggleDark, size = 28, offset = 8 }) => (
  <ButtonGroup $bottom={offset} $right={offset} $gap={4}>
    <ActionButton $size={size} onClick={onDownload} title="Download image">
      <FontAwesomeIcon icon={faDownload} />
    </ActionButton>
    <ActionButton $size={size} onClick={onToggleDark} title="Toggle light/dark background">
      <FontAwesomeIcon icon={faMoon} />
    </ActionButton>
  </ButtonGroup>
);

const ButtonGroup = styled.div<{ $bottom: number; $right: number; $gap: number }>`
  position: absolute;
  bottom: ${(p) => p.$bottom}px;
  right: ${(p) => p.$right}px;
  display: flex;
  flex-direction: row;
  gap: ${(p) => p.$gap}px;
  z-index: 5;
`;

const ActionButton = styled.button<{ $size: number }>`
  width: ${(p) => p.$size}px;
  height: ${(p) => p.$size}px;
  padding: 0;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
  color: #607d8b;
  font-size: ${(p) => Math.round(p.$size * 0.43)}px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    color: #455a64;
    background-color: #fff;
    transform: scale(1.1);
  }
`;
